import '../index.css';
var styles = {
  "container": "bp_select_module_container--6b68f",
  "disabled": "bp_select_module_disabled--6b68f",
  "label": "bp_select_module_label--6b68f",
  "triggerBtn": "bp_select_module_triggerBtn--6b68f",
  "readonly": "bp_select_module_readonly--6b68f",
  "error": "bp_select_module_error--6b68f",
  "iconWrapper": "bp_select_module_iconWrapper--6b68f",
  "iconCaret": "bp_select_module_iconCaret--6b68f",
  "iconPencilCrossed": "bp_select_module_iconPencilCrossed--6b68f",
  "icon": "bp_select_module_icon--6b68f",
  "content": "bp_select_module_content--6b68f",
  "viewport": "bp_select_module_viewport--6b68f",
  "option": "bp_select_module_option--6b68f",
  "secondaryText": "bp_select_module_secondaryText--6b68f",
  "indicator": "bp_select_module_indicator--6b68f",
  "separator": "bp_select_module_separator--6b68f"
};
export { styles as default };